import { format } from "date-fns";
import React, { useRef } from "react";
import { Button, useDayPicker, useDayRender } from "react-day-picker";
const DayButton = (props) => {
    const buttonRef = useRef(null);
    const dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    const { locale } = useDayPicker();
    const dateTime = format(props.date, "cccc d", { locale });
    if (dayRender.isHidden) {
        return React.createElement(React.Fragment, null);
    }
    if (!dayRender.isButton) {
        return React.createElement("div", Object.assign({}, dayRender.divProps));
    }
    return (React.createElement(Button, Object.assign({ name: "day", ref: buttonRef }, dayRender.buttonProps, { role: undefined, "aria-label": dateTime, "aria-hidden": dayRender.activeModifiers.outside, "aria-selected": undefined, "aria-pressed": !!dayRender.activeModifiers.selected })));
};
export default DayButton;
//# sourceMappingURL=DayButton.js.map